<div class="container">
    <div class="row">
        <div class="col page">
            <div class="row">
                <div class="col-12 mb-3">
                    <a [routerLink]="['/my-garage']" class="breadcrumb noselect"><span class="fa-solid fa-chevron-left"></span> My Garage</a>
                </div>
            </div>
            <!-- <div *ngIf="!isEditing" class="row"> 
                <div class="col-12 title">
                    <span class="noselect">{{ vehicleDetails?.Year }}</span>
                    <span class="noselect">&nbsp;{{ vehicleDetails?.Make }},</span>
                    <span class="noselect">&nbsp;{{ vehicleDetails?.Model }}</span>
                </div>
                <div class="col-12 vin noselect">
                    VIN: <span>{{ vehicleDetails?.Vin }}</span>
                </div>
            </div> -->
            <div class="row align-items-center">
                <div *ngIf="isEditing" class="col-12 text-center mb-3">
                    <h3 class="noselect"><strong>Editing Vehicle</strong></h3>
                    <span>Mark all necessary image and detail edits, then click "Submit Updates"</span>
                </div>
                <div class="col-12 col-md-6 order-1 order-md-1">
                    <div class="noselect primary-image-container">
                        <img *ngIf="!isEditing" [src]="mainImageSrc" alt="Vehicle Primary Image" class="primary-image">
                        <ng-container *ngIf="isEditing">
                            <div
                                class="upload-drop-zone"
                                (drop)="onDrop($event)"
                                (dragover)="onDragOver($event)"
                                (click)="fileInput.click()">
                                <p class="upload-text">Drag image or</p>
                                <p class="upload-link">click</p>
                                <p class="upload-text">to upload</p>
                            </div>
                            <input
                                #fileInput
                                id="vehicle-image-upload"
                                type="file"
                                accept="image/*"
                                multiple
                                style="display: none;"
                                (change)="onImageSelected($event)">
                        </ng-container>
                    </div>
                    <!-- Mobile: open the rear camera directly. The hidden input sits
                         outside the isEditing container so the ref is in scope. -->
                    <input
                        #cameraInput
                        type="file"
                        accept="image/*"
                        capture="environment"
                        style="display: none;"
                        (change)="onImageSelected($event)">
                    <button *ngIf="isEditing"
                            type="button"
                            class="btn btn-outline-secondary w-100 mt-2 d-sm-none noselect"
                            (click)="cameraInput.click()">
                        <span class="fa-solid fa-camera me-1"></span>Take Photo
                    </button>
                    <div *ngIf="isEditing && imageUploadPreviews.length > 0" class="upload-previews-section">
                        <h5 class="upload-section-title">Images for Upload</h5>
                        <div class="row upload-previews-grid mx-0">
                            <div *ngFor="let preview of imageUploadPreviews; let i = index" class="col-6 col-lg-4 upload-preview-col px-0">
                                <div class="upload-preview-wrapper noselect">
                                    <img [src]="preview.previewUrl" alt="Upload Preview" class="upload-preview-image">
                                    <span class="fa-solid fa-circle-xmark upload-delete-icon" (click)="onRemoveUploadPreview(i)"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 order-2 order-md-2">
                    <!-- <h5><strong>Vehicle Images</strong></h5> -->
                    <ngb-carousel
                      [showNavigationArrows]="(vehicleDetails?.VehicleImages?.length || 0) > vehicleThumbPageSize"
                      [showNavigationIndicators]="(vehicleDetails?.VehicleImages?.length || 0) > vehicleThumbPageSize" class="vehicle-thumb-carousel">
                        <ng-template ngbSlide *ngFor="let thumbPage of vehicleThumbPages">
                            <div class="row thumb-row mx-0">
                                <div *ngFor="let vehicleThumb of thumbPage"
                                  [ngClass]="{
                                    'active': mainImageSrc === vehicleThumb.ImageUrl && !isEditing }"
                                  class="col-6 col-lg-4 thumb-col px-0 noselect">
                                    <div class="thumb-wrapper">
                                        <img [src]="vehicleThumb.ImageUrl" alt="Thumb Image" class="thumb-image" (click)="onThumbClick(vehicleThumb)">
                                        <div *ngIf="isEditing" class="editing-mask">
                                            <div *ngIf="isEditing" class="delete-text" [ngClass]="{ 'primary': vehicleThumb.ImageId === getPrimaryOrEditImageId() }" (click)="onImageDelete(vehicleThumb)">
                                                <span *ngIf="!filesForDeletion.has(vehicleThumb.ImageId)">Mark for deletion</span>
                                                <span *ngIf="filesForDeletion.has(vehicleThumb.ImageId)" class="marked fa-solid fa-trash"></span>
                                            </div>
                                            <div *ngIf="isEditing" (click)="onPrimaryClick(vehicleThumb)" class="primary-text">
                                                <span *ngIf="vehicleThumb.ImageId !== getPrimaryOrEditImageId()">Mark as primary</span>
                                                <span *ngIf="vehicleThumb.ImageId === getPrimaryOrEditImageId()"><i class="primary fa-solid fa-crown"></i></span>
                                            </div>
                                        </div>
                                        <span *ngIf="isEditing" [ngClass]="{ 'primary': vehicleThumb.ImageId === getPrimaryOrEditImageId() }" class="fa-solid fa-circle-xmark delete-icon" (click)="onImageDelete(vehicleThumb)"></span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngb-carousel>
                </div>
            </div>
            <div class="row">
                <div *ngIf="!isEditing" class="col-12 title">
                    <span>{{ vehicleDetails?.Year }}</span>
                    <span>&nbsp;{{ vehicleDetails?.Make }},</span>
                    <span>&nbsp;{{ vehicleDetails?.Model }}</span>
                </div>
                <div *ngIf="!isEditing" class="col-12 vin">
                    VIN: <span>{{ vehicleDetails?.Vin }}</span>
                </div>
                <div *ngIf="!isEditing && vehicleDetails?.LicensePlate" class="col-12 vin">
                    Plate: <span>{{ vehicleDetails?.LicensePlate }}</span>
                </div>
                <div *ngIf="isEditing" class="col-12">
                    <form [formGroup]="vehicleDetailsForm" (ngSubmit)="onSubmitVehicleEdits()" class="row justify-content-center mt-5">
                        <div class="col-12 col-lg-10">
                            <app-vehicle-form-fields [form]="vehicleDetailsForm"></app-vehicle-form-fields>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-primary">Submit Updates</button>
                            <button type="button" (click)="onDiscardChanges()" class="btn btn-warning ml-2">Discard Changes</button>
                        </div>
                        <div class="col-12 text-center">
                            <!-- Staff-only repair for a vehicle recorded under the wrong customer. -->
                            <button *ngIf="canTransferVehicle"
                                    (click)="onTransferVehicleClick()"
                                    type="button"
                                    class="btn btn-outline-primary mt-3 me-2">Transfer Owner</button>
                            <button (click)="onDeleteVehicleClick()" type="button" class="btn btn-danger mt-3">Delete Vehicle</button>
                        </div>
                    </form>
                </div>
                <div *ngIf="!isEditing" class="col-12 text-center">
                    <button (click)="toggleIsEditing()" class="btn btn-primary">Edit Vehicle</button>
                </div>
                <div class="col-12 service-history">
                    <span class="history">Service History</span>

                    <div *ngIf="historyLoading" class="history-state noselect">Loading service history…</div>
                    <div *ngIf="!historyLoading && historyError" class="history-state history-error noselect">{{ historyError }}</div>
                    <div *ngIf="!historyLoading && !historyError && serviceHistory.length === 0" class="history-state noselect">
                        No completed services yet.
                    </div>

                    <div *ngIf="!historyLoading && !historyError && serviceHistory.length > 0" class="history-table-wrapper">
                        <table class="history-table">
                            <thead>
                                <tr>
                                    <th class="col-service">Service</th>
                                    <th class="col-num">Mileage</th>
                                    <th class="col-mechanic">Mechanic</th>
                                    <th class="col-num">Line Item Cost</th>
                                    <th class="col-view">View Invoice</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let invoice of serviceHistory">
                                    <tr *ngFor="let item of invoice.WorkItems" class="work-item-line">
                                        <td class="col-service" data-label="Service">{{ item.Title }}</td>
                                        <td class="col-num" data-label="Mileage">{{ item.Miles != null ? (item.Miles | number) : '—' }}</td>
                                        <td class="col-mechanic" data-label="Mechanic">{{ mechanicName(item) }}</td>
                                        <td class="col-num" data-label="Line Item Cost">{{ item.LineTotal | currency }}</td>
                                        <!-- No PDF link for a previous owner's invoice: the work
                                             history follows the car, the invoice does not. -->
                                        <td class="col-view" data-label="Invoice">
                                            <button *ngIf="invoice.CanViewInvoice"
                                                    type="button"
                                                    class="btn-icon"
                                                    title="View invoice PDF"
                                                    (click)="openInvoicePdf(invoice.InvoiceId)">
                                                <span class="fa-solid fa-file-pdf"></span>
                                            </button>
                                            <span *ngIf="!invoice.CanViewInvoice" class="noselect">—</span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
